import { useQuery, UseQueryResult } from 'react-query';
import { fetchSites } from 'api/site';
import { Site } from 'types/site';
import { washHub } from 'store';

type SiteStatus = 'active' | 'in-active' | 'archived';

const useSiteWithStatus = (status: SiteStatus): UseQueryResult<Site[]> => {
  const activeOnly =
    status === 'active' ? 1 : status === 'in-active' ? 2 : undefined;
  const archived = status === 'archived' ? 1 : undefined;
  const washHubId = washHub.selectors.useSelectedWashHubId();
  const queryKey = [`fetch-sites-${washHubId}`, status];
  const queryFn = () => fetchSites(washHubId, activeOnly, archived);
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();
  const options = {
    enabled: isWashHubIdValid,
    keepPreviousData: true,
  };

  return useQuery(queryKey, queryFn, options);
};

export default useSiteWithStatus;
